/* tslint:disable */
/* eslint-disable */
/**
 * Validations API
 * Validator side of the quote validation requests
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * The validator refuses the quote; the message explaining why is mandatory.
 * @export
 * @interface RefuserDemandeCommand
 */
export interface RefuserDemandeCommand {
    /**
     * 
     * @type {string}
     * @memberof RefuserDemandeCommand
     */
    message: string;
}

/**
 * Check if a given object implements the RefuserDemandeCommand interface.
 */
export function instanceOfRefuserDemandeCommand(value: object): value is RefuserDemandeCommand {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function RefuserDemandeCommandFromJSON(json: any): RefuserDemandeCommand {
    return RefuserDemandeCommandFromJSONTyped(json, false);
}

export function RefuserDemandeCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): RefuserDemandeCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
    };
}

export function RefuserDemandeCommandToJSON(json: any): RefuserDemandeCommand {
    return RefuserDemandeCommandToJSONTyped(json, false);
}

export function RefuserDemandeCommandToJSONTyped(value?: RefuserDemandeCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
    };
}

